import { Boxes, Package, ShoppingBag, Truck } from "lucide-react";
import React from "react";
import { PackagingLevelKey } from "../types/packagingDetail.types";

export const LEVEL_ICONS: Record<PackagingLevelKey, React.ComponentType<{ className?: string }>> = {
  singleUnitPackaging: Package,
  salesUnitPackaging: ShoppingBag,
  bulkUnitPackaging: Boxes,
  transportUnitPackaging: Truck
};
